// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class PatrolGeoResource extends Resource {
    basePath: string = 'patrols/patrols/geo/';

    objectPath: string = 'patrols/patrols/geo/{ident}/';
}
